import { CreateGroupDto } from '../../../dto/creategroup/creategroupdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface CreateGroupRequest extends APIRequest
{
    getCreateGroupRequest(): CreateGroupDto;
}

export class CreateGroupRequestImpl extends APIRequestDtoImpl implements CreateGroupRequest
{
    constructor(private getCreateGroupData: CreateGroupDto)
    {
        super();
    }

    getCreateGroupRequest(): CreateGroupDto
    {
        return this.getCreateGroupData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/creategroup/creategrouprequest.tsx